import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8, getPageLayoutType, getPathName } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const NetbillingContext = createContext();
export const ACTIONS = {
  SET_RESUME_TICKET: "SET_RESUME_TICKET",
  SET_LOAD_PAGE: "SET_LOAD_PAGE",
  SET_IDCTACTO: "SET_IDCTACTO",
  SET_IDLIST: "SET_IDLIST",
  SET_HISTORY_CONSU: "SET_HISTORY_CONSU",
  SET_RESPONSE_DOC: "SET_RESPONSE_DOC",
  SET_LIST_TICKETS: "SET_LIST_TICKETS",
  SET_RESPONSE_DETAIL_TICKET_PDF: "SET_RESPONSE_DETAIL_TICKET_PDF",
  SET_ERROR: "SET_ERROR",
  SET_PAGE_LAST_TICKETS: "SET_PAGE_LAST_TICKETS",
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",

};
const initialState = {
  resumeTicket: null,
  errorFetch: null,
  idList: null,
  loadPage: false,
  idCtaCto: 0,
  historyConsu: null,
  responseDoc: 0,
  listTickets: null,
  responseDetailTicketPDF: null,
  setPageLastTickets: false,
  idClient: null,
  detailClient: null,
  webContentTextInfo: "",

};
const NetbillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_IDCTACTO: {
      return {
        ...state,
        idCtaCto: action.payload,
      };
    }
    case ACTIONS.SET_RESUME_TICKET: {
      return {
        ...state,
        resumeTicket: action.payload,
      };
    }
    case ACTIONS.SET_HISTORY_CONSU: {
      return {
        ...state,
        historyConsu: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_DOC: {
      return {
        ...state,
        responseDoc: action.payload,
      };
    }
    case ACTIONS.SET_LOAD_PAGE: {
      return {
        ...state,
        loadPage: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_LIST_TICKETS: {
      return {
        ...state,
        listTickets: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_DETAIL_TICKET_PDF: {
      return {
        ...state,
        responseDetailTicketPDF: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    case ACTIONS.SET_PAGE_LAST_TICKETS: {
      return {
        ...state,
        setPageLastTickets: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idClient: action.payload
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
const NetbillingContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(NetbillingReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);

  useEffect(() => {

    if (state.idCtaCto) {
        LiferayService.consultarDetalleCuentaContratoSL(properties.base_url_api, state.idCtaCto, properties.url_ws_empresa, properties.codigo_empresa)
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_DETAIL_CLIENT,
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR,
            });
            setTimeout(() => {
              if(response.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0){

                LiferayService.getListLastTickets(properties.base_url_api, state.idCtaCto, properties.qnt_list_boletas, properties.codigo_empresa, properties.url_ws_empresa)
                  .then((tickets) => {
                    dispatch({
                      payload: tickets,
                      type: ACTIONS.SET_LIST_TICKETS,
                    });
                  })
                
                if(accessToken !== "not-a-cognito-user" && accessToken) {

                  LiferayService.getNetbilling(properties.base_url_api, state.idCtaCto, properties.codigo_empresa, properties.url_ws_empresa)
                  .then((response) => {
          
                    dispatch({
                      payload: response,
                      type: ACTIONS.SET_RESUME_TICKET,
                    });
          
                    LiferayService.getResponseDoc(properties.base_url_api, state.idCtaCto, properties.url_ws_empresa, properties.codigo_empresa, response.nroDocumento)
                      .then((response) => {
                        dispatch({
                          payload: response,
                          type: ACTIONS.SET_RESPONSE_DOC,
                        });
                      })
          
                  }).then(() => {
                    LiferayService.getHistoryConsu(properties.base_url_api, state.idCtaCto, properties.url_ws_empresa)
                      .then((response2) => {
                        dispatch({
                          payload: response2,
                          type: ACTIONS.SET_HISTORY_CONSU,
                        });
                      })
                      if (getPathName() === 'detalle-de-boleta') {
                        dispatch({
                          payload: "",
                          type: ACTIONS.SET_IDCTACTO,
                        })
                      }
                  })

                }
              } else {
                if (getPathName() === 'detalle-de-boleta') {
                  dispatch({
                    payload: "",
                    type: ACTIONS.SET_IDCTACTO,
                  })
                }
              }
            }, 500);
          })
        
          .catch((error) => {
            dispatch({
              payload: error,
              type: ACTIONS.SET_ERROR,
            });
          })
      
    }

  }, [state.idCtaCto]);

  useEffect(() => {

    if(accessToken){
      LiferayService.getIdList(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_IDLIST,
        });
        dispatch({
          payload: false,
          type: ACTIONS.SET_LOAD_PAGE,
        });
      })
    }
  },[accessToken])

  useEffect(() => {
    if (state.loadPage) {
      if (decode_utf8(properties.web_content_info_update_of_contact_information).trim()) {
        LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_info_update_of_contact_information).trim())
          .then((response) => {
            dispatch({
              payload: response,
              type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
            });
          })
        }
    }
  }, [state.loadPage]);

  return (
    <NetbillingContext.Provider value={[state, dispatch]}>
      {children}
    </NetbillingContext.Provider>
  );
};
export default NetbillingContextProvider;